import React from 'react';

export default props => {
    return (
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 10V2M4 2L1 4.85714M4 2L7 4.85714" stroke="#F2C94C" stroke-width="2"/>
        </svg>
    );
};
